module.exports = __webpack_public_path__ + "../resources/img/ic_wind_weather.e40730db.svg";